const TYPE_TO_CAMEL = {
  LATE_CLOCK_IN: 'lateClockIn',
  EARLY_CLOCK_OUT: 'earlyClockOut',
  NOT_CLOCK_OUT: 'notClockOut',
  OUT_OF_LOCATION_RANGE: 'outOfLocationRange',
  NOT_VALID_LOCATION: 'notValidLocation',
  NOT_STREAM: 'notStream',
};

const violationTypeToText = (type, t) => {
  const camelKey = TYPE_TO_CAMEL[type];
  if (camelKey) {
    return {
      label: t(`violation_type.${camelKey}`),
      key: type,
    };
  }
  return {
    label: type,
    key: type,
  };
};

export default violationTypeToText;
